import { onMounted, ref, computed, getCurrentInstance } from 'vue';

export function useModal() {
    const instance = ref();
    const $bvModal = computed(() => instance.value?.ctx?._bv__modal);

    onMounted(() => {
        instance.value = getCurrentInstance();
    });
    return {
        $bvModal: $bvModal,
    };
}
